module.exports = __webpack_public_path__ + "static/media/tg2.52e0560a.jpg";